import {AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn} from '@angular/forms';
import {Directive, Input} from '@angular/core';
import moment from 'moment';
import {Mask, MaskValidatorFunctions} from '../../interfaces/mask';

export function datefieldValidator(mask: Mask<MaskValidatorFunctions>, format: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    if (moment.isMoment(control.value)) {
      return control.value.isValid() ? null : {invalidDate: true};
    }

    if (!moment(control.value, format, true).isValid()) {
      return {invalidDate: true};
    }

    const dayInMonths = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    const ev = control.value;
    const [day, month, year] = ev.split('/');
    const monthsArray = dayInMonths
      .map((el, i) => {
        return {month: i + 1, days: el};
      })
      .filter((el) => day <= el.days);

    if (
      monthsArray.length === 0 ||
      (month > 0 &&
        !monthsArray.find((el) => {
          return el.month == month;
        }))
    ) {
      return {invalidDay: true};
    }

    if (ev.length == 10) {
      const dateInput = moment(ev, format || 'DD/MM/YYYY', true);
      if (!dateInput.isValid()) {
        return {invalidDate: true};
      }
    }

    return null;
  };
}

@Directive({
    selector: '[dateValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: DateValidatorDirective,
            multi: true,
        },
    ],
    standalone: false
})
export class DateValidatorDirective implements Validator {
  @Input() customMask?: Mask<MaskValidatorFunctions>;
  @Input() azDateFormatter?: string;
  validate(control: AbstractControl): ValidationErrors | null {
    return this.customMask && this.azDateFormatter ? datefieldValidator(this.customMask, this.azDateFormatter)(control) : null;
  }
}
